import React, { useEffect, useState } from "react";
import Header from "../../components/header1/Header1";
import Footer from "../../components/footer/Footer";
import PartnerInstitutions from "../../components/partner/Partner";
import landing2 from "../../elements/Group 170.png";
import bannerImage from "../../elements/Group 129.png";

import { SlCalender } from "react-icons/sl";
import { FaEnvelope, FaPhone, FaLinkedin, FaPhoneAlt } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { SlCloudUpload } from "react-icons/sl";
import { LiaFileUploadSolid } from "react-icons/lia";
import {
  getMentors,
  getProjectDetails,
  uploadFile,
  getUploadedFile,
} from "../../services/studentportalapis";
import { IoMail } from "react-icons/io5";
import { json } from "react-router-dom";

const MyInternshipPlan = () => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [instituteMentors, setInstituteMentors] = useState([]);
  const [collegeProfilePhoto, setcollegeProfilePhoto] = useState([]);
  const [collegeName, setcollegeName] = useState([]);
  const [collegeCity, setcollegeCity] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [url, setUrl] = useState(null);
  const [projectDetails, setProjectDetails] = useState([]);
  const [teamId] = useState(
    JSON.parse(localStorage.getItem("student-details"))["teamId"]
  );
  const [file, setFile] = useState(null);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [showViewButton, setShowViewButton] = useState(false);
  const [error, setError] = useState("");

  // Handle file input change
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  useEffect(() => {
    if (teamId) {
      // Fetch mentor details based on teamId
      const fetchMentors = async () => {
        try {
          const data = await getMentors(teamId);
          console.log("mentor data :", data);
          setInstituteMentors(data); // Update state with API data
        } catch (error) {
          console.error("Error fetching mentor details:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchMentors();
    }
  }, [teamId]);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        setLoading(true);
        const data = await getProjectDetails(teamId);
        console.log("data is", data);

        setProjectDetails(data);
      } catch (error) {
        console.error("Error fetching project details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectDetails();
  }, [teamId]);

  const handlePopupClose = () => setShowPopup(false);

  useEffect(() => {
    const fetchData = () => {
      setLoading(false);
    };
    fetchData();
  }, []);

  const fetchUploadedFileStatus = async () => {
    try {
      // Check if the file is already uploaded
      const url = await getUploadedFile(teamId);
      if (url) {
        
        if(url==null){
          throw setError("url is null")

        }else{

          console.log("url", url);
        setUrl(url);
        window.open(url, "_blank");
        
        setShowSubmitButton(false); // Disable the submit button
        setShowViewButton(true); // Enable the view button

        }
        
      } else {
        // If no URL is returned, the file might be deleted, reset buttons
        setShowSubmitButton(true); // Enable the submit button
        setShowViewButton(false); // Disable the view button
      }
    } catch (error) {
      console.error("Error fetching uploaded file:", error);
      setShowSubmitButton(true); // Enable the submit button in case of error
      setShowViewButton(false); // Disable the view button in case of error
    }
  };

  useEffect(() => {
    fetchUploadedFileStatus(); // Call the function on component mount
  }, [teamId]);

  const handleFileUpload = async (e) => {
    // const file = e.target.files[0]; // Get the first file
    if (!file) {
      alert("Please select a file first!"); // Alert if no file is selected
      return;
    }

    // Simulating file upload logic (e.g., sending the file to a server or processing it)
    console.log("File uploaded:", file);

    // Alert after successful file upload
    alert("File uploaded successfully!");

    if (file) {
      // Allowed MIME types
      const allowedTypes = [
        "application/vnd.ms-powerpoint", // .ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
        "application/pdf",
      ];

      // Validate file type using MIME type
      if (!allowedTypes.includes(file.type)) {
        alert("Invalid file type. Please upload only PPT or PPTX files.");
        e.target.value = ""; // Clear the input
        return;
      }

      // File is valid, proceed to set the file
      setUploadedFile(file);

      await uploadFile(file, teamId);

      setShowViewButton(true);
      setShowSubmitButton(false);
    }
  };

  // const handleFileUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const allowedTypes = ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/pdf"];
  //     if (!allowedTypes.includes(file.type)) {
  //       alert("Invalid file type. Please upload only PPT, PPTX, or PDF.");
  //       e.target.value = "";
  //       return;
  //     }
  //     setUploadedFile(file);
  //     await uploadFile(file);
  //   }
  // };

  const viewUploadedFile = async () => {
    try {
      const url = await getUploadedFile(teamId);
      setUrl(url);
      if (url) {
        console.log(url);

        // window.open(file.url, "_blank");
      }
    } catch (error) {
      alert("Error fetching file.");
    }
  };

  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  return (
    <div className="text-gray-800 md:mx-20 sm:mx-10">
      <Header />
      <div className="relative w-full">
        <img
          src={bannerImage}
          alt="Banner"
          className="w-full  sm:h-[300px] h-auto object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-medium p-4 sm:p-6">
          <div className="flex flex-col w-full sm:w-2/5 p-3">
            <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Get Ready for Hands-On Learning with Industry
            </p>
          </div>
        </div>
      </div>
      <div className="mainPage text-base xl:text-4xl">
        <div className="flex flex-col md:flex-row items-center py-10 gap-6 ">
          <div className="w-full md:w-1/2">
            <img
              src={landing2}
              alt="Learning Program"
              className="w-full h-auto"
            />
          </div>
          <div className="w-full md:w-1/2 leading-relaxed text-gray-700 space-y-2 px-4 md:px-0">
            <p className="text-left font-medium md:text-2xl sm:text-lg ">
              Our internship program gives students real-world experience on
              live industry projects, tackling the same challenges faced by top
              AI and software firms. This hands-on approach ensures you are not
              just learning theory but applying it
            </p>
          </div>
        </div>

        <div className="py-10 px-5 md:px-20">
          <div className="flex flex-col justify-center items-center mb-6">
            {instituteMentors && collegeProfilePhoto ? (
              <img
                src={collegeProfilePhoto}
                alt="College Logo"
                className="object-contain"
                style={{ height: "100%", width: "auto" }}
              />
            ) : null}

            {instituteMentors && (
              <p className="text-center text-gray-500 my-2">
                {collegeName} , {collegeCity}
              </p>
            )}
          </div>

          <h2 className="text-center text-3xl font-bold mb-4">
            Summer Internship
          </h2>
          <div className="text-center ">
            <div className="bg-white py-4 px-4 border-2 rounded-md">
              <h4 className="font-bold text-xl px-2 text-gray-800 text-left mb-0">
                Project Title
              </h4>
              <div className="font-semibold text-gray-800 text-left text-lg px-2">
                {projectDetails.projectTitle}
              </div>
            </div>

            <div className="flex flex-col md:flex-row justify-between gap-2 md:gap-8 my-6">
              <div className="flex items-center bg-white w-full md:w-1/2 py-2 border-2 rounded-lg justify-between">
                <div className="flex md:flex-row flex-col justify-around place-items-baseline px-4">
                  <h4 className="text-xl font-bold m-2  text-gray-800 text-left">
                    Start Date:
                  </h4>
                  <div className="font-semibold text-gray-800 text-center items-center text-base md:px-2">
                    {projectDetails.startDate}
                  </div>
                </div>
                <SlCalender className="text-gray-500 text-xl  mr-4" />
              </div>

              <div className="flex items-center bg-white w-full md:w-1/2 py-2 border-2 rounded-lg justify-between  ">
                <div className="flex md:flex-row flex-col justify-around place-items-baseline px-4">
                  <h4 className="text-xl font-bold m-2  text-gray-800 text-left">
                    End Date:
                  </h4>
                  <div className="font-semibold text-gray-800 text-left items-center text-base md:px-2">
                    {projectDetails.endDate}
                  </div>
                </div>
                <SlCalender className="text-gray-500 text-xl  mr-4" />
              </div>
            </div>

            <div className="mt-4 border-2 px-4 rounded-lg ">
              <h4 className="text-xl font-bold m-2 text-gray-800 text-left">
                My Team
              </h4>
              <div className="flex justify-between overflow-x-auto">
                {/* Dynamically map over the students in the team */}
                {projectDetails?.team?.students?.map((student, index) => (
                  <div
                    key={index}
                    className="flex flex-col text-center justify-between md:justify-around items-center"
                  >
                    {/* <div className="md:w-32 md:h-32 w-16 h-16 bg-gray-300 mx-auto"></div> */}
                    {/* Display the student's name */}
                    <div className="m-2 px-4 py-2 text-center rounded-md mx-2 items-center md:mx-20 bg-gray-100 h-full md:h-auto">
                      <div className=" text-gray-700 text-xl text-left font-semibold ">
                        {student.firstName} {student.lastName}
                      </div>

                      <hr className="flex  my-1 text-gray-500 w-1/2"></hr>

                      <div className="text-gray-500 flex text-base items-center text-left">
                        <IoMail className="mr-2" />
                        {student.email}
                      </div>
                      <div className="text-gray-500 flex text-base   md:justify-start my-1 text-left">
                        <FaPhoneAlt className="mr-2" />
                        {student.phone}
                      </div>

                      <div className="text-blue-500 flex text-base justify-center md:justify-start text-left">
                        <FaLinkedin className="mr-2 text-xl" />
                        <a
                          href={student.linkedinUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="underline"
                        >
                          {student.linkedinUrl}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {instituteMentors && (
          <div className="py-2 border-b-2">
            <section className=" py-4  px-8 md:px-12 md:py-14 ">
              <div className="flex items-center justify-between w-full">
                <div className="flex items-left">
                  <p className="text-4xl md:text-4xl font-bold text-gray-800 text-left leading-tight">
                    Institute Mentor
                  </p>
                </div>
              </div>

              <div className="max-w-4xl  flex flex-col justify-center ">
                {instituteMentors.map((mentorData) => (
                  <div
                    key={mentorData.mentor.mentorId}
                    className="py-4  flex flex-col md:flex-row items-start "
                  >
                    <div className="w-full md:w-1/4 ">
                      <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-28 md:h-28 lg:w-36 lg:h-36 rounded-full border-gray-200 border-1 overflow-hidden bg-gray-200 flex justify-start items-left mb-4 sm:mb-0 mx-2">
                        <img
                          src={mentorData.mentor.profilePhoto}
                          alt={`${mentorData.mentor.mentorName}`}
                          className="object-cover w-full h-full"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col md:ml-6 lg:ml-8 w-full">
                      <p className="text-3xl md:text-3xl sm:text-xl font-semibold text-blue-800 text-left">
                        {mentorData.mentor.mentorName}
                      </p>
                      <p className="text-black-600 font-semibold text-left text-wrap leading-5 text-normal md:text-normal xs:text-base sm:leading-5 break-words">
                        {mentorData.mentor.mentorBio}
                      </p>
                      <hr className="border-t-2" />
                      <div className="flex flex-col mt-2 pl-2 justify-between md:flex-row md:items-center text-gray-600 space-y-1 md:space-x-1 md:space-y-0">
                        <a
                          href={`mailto:${mentorData.mentor.mentorEmail}`}
                          className="flex items-center hover:text-gray-800 text-left"
                        >
                          <CiMail className="w-5 h-5 mr-2 top-1/2 transform -translate-y-1/2" />
                          <p className="font-normal text-sm">
                            {mentorData.mentor.mentorEmail}
                          </p>
                        </a>

                        <a
                          href={mentorData.mentor.mentorLinkedIn}
                          className="flex items-center hover:text-gray-800 text-left"
                        >
                          <FaLinkedin className="w-5 h-5 mr-2 top-1/2 transform -translate-y-1/2 text-[#0A66C2]" />
                          <p className="font-normal text-sm">
                            Connect via LinkedIn
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        )}

        {instituteMentors && (
          <div className="py-2">
            <section className="py-4 px-8 md:px-12 md:py-14">
              <div className="flex items-center justify-between w-full">
                <div className="flex items-left">
                  <p className="text-4xl md:text-4xl font-bold text-gray-800 text-left leading-tight">
                    Agivant Mentor
                  </p>
                </div>
              </div>

              <div className="max-w-4xl flex flex-col justify-center">
                {instituteMentors.map((mentorData) => (
                  <div
                    key={mentorData.agivantMentor.agivant_mentor_id}
                    className="py-4 flex flex-col md:flex-row items-start"
                  >
                    <div className="w-full md:w-1/4">
                      <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-28 md:h-28 lg:w-36 lg:h-36 rounded-full border-gray-200 border-1 overflow-hidden bg-gray-200 flex justify-start items-left mb-4 sm:mb-0 mx-2">
                        <img
                          src={mentorData.agivantMentor.profilePhoto}
                          alt={`${mentorData.agivantMentor.mentorName}`}
                          className="object-cover w-full h-full"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col md:ml-6 lg:ml-8 w-full">
                      <p className="text-3xl md:text-3xl sm:text-xl font-semibold text-blue-800 text-left">
                        {mentorData.agivantMentor.mentorName}
                      </p>
                      <p className="text-black-600 font-semibold text-left text-wrap leading-5 text-normal md:text-normal xs:text-base sm:leading-5 break-words">
                        {mentorData.agivantMentor.mentorBio}
                      </p>
                      <hr className="border-t-2" />
                      <div className="flex flex-col mt-2 pl-2 justify-between md:flex-row md:items-center text-gray-600 space-y-1 md:space-x-1 md:space-y-0">
                        <a
                          href={`mailto:${mentorData.agivantMentor.mentorEmail}`}
                          className="flex items-center hover:text-gray-800 text-left"
                        >
                          <CiMail className="w-5 h-5 mr-2 top-1/2 transform -translate-y-1/2" />
                          <p className="font-normal text-sm">
                            {mentorData.agivantMentor.mentorEmail}
                          </p>
                        </a>

                        <a
                          href={mentorData.agivantMentor.mentorLinkedIn}
                          className="flex items-center hover:text-gray-800 text-left"
                        >
                          <FaLinkedin className="w-5 h-5 mr-2 top-1/2 transform -translate-y-1/2 text-[#0A66C2]" />
                          <p className="font-normal text-sm">
                            Connect via LinkedIn
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        )}

        <div className="md:py-10 px-5 md:px-20 text-center">
          <div className="flex flex-col items-center gap-2">
            <p
              htmlFor="file-upload"
              onClick={setShowPopup}
              className="cursor-pointer flex items-center gap-2 border-blue-700  border-2 text-blue-700 px-8 py-3 rounded-lg hover:bg-blue-600 hover:text-white transition"
            >
              {/* <SlCloudUpload className="text-4xl" /> */}
              <LiaFileUploadSolid className="text-4xl" />
              Upload Final Project Presentation
            </p>
            <div className="text-center">
              <p className="cursor-pointer flex items-center border-blue-700 bg-gray-400  text-white px-10 py-3 rounded-lg">
                My Internship Completion Certificate
              </p>
            </div>
          </div>
        </div>

        {showPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
            <div className="bg-white pb-6 px-6 pt-3 rounded-md shadow-lg mx-auto relative w-full max-w-2xl">
              <button
                onClick={handlePopupClose}
                className="absolute top-2 bg-white right-4 text-gray-500 text-2xl"
              >
                &times;
              </button>

              <h2 className="text-lg text-left font-bold mt-0 mb-2">
                Upload Document
              </h2>

              <div className="flex flex-col items-center justify-center rounded-lg border-dotted border-2 border-blue-800 p-6 mb-2 text-center">
                <SlCloudUpload className="text-gray-500 font-bold text-4xl " />
                <p className="text-gray-700 font-semibold text-base mb-2">
                  Drag and drop files here
                </p>

                {!showViewButton && (
                  <input
                    type="file"
                    onChange={handleFileChange}
                    className="cursor-pointer bg-white text-blue-800 py-2 px-4 rounded-md border-2 border-gray-300 text-sm mt-2"
                    accept=".ppt, .pptx, .pdf" // Restrict file types
                  />
                )}

                <div className="flex flex-col gap-y-4">
                  <div className="text-gray-400 font-semibold mt-2 md:text-sm leading-4">
                    <div className="text-gray-400 font-semibold mt-2 md:text-sm tracking-wide leading-4">
                      Supported: PPT, PPTX, PDF
                    </div>
                    <div className="text-gray-400 font-semibold md:text-sm tracking-wide leading-4">
                      File size should be maximum 25mb and shouldn't be password
                      protected
                    </div>
                  </div>

                  {/* Submit Button for Upload */}
                  {showSubmitButton && (
                    <div className="text-center">
                      <button
                        onClick={handleFileUpload}
                        className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div>

                {/* View button is shown only when the file is uploaded */}
                {showViewButton && (
                  <div className="mt-4 text-center">
                    <button
                      onClick={fetchUploadedFileStatus}
                      className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    >
                      View Uploaded File
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* <PartnerInstitutions /> */}
      </div>
      <Footer />
    </div>
  );
};

export default MyInternshipPlan;
